import styled from '@emotion/styled';
import { TableHeaderCell } from 'semantic-ui-react';

export const NonSortableTableHeaderCell = styled(TableHeaderCell)`
  &:hover {
    background: none !important;
    color: inherit !important;
    cursor: default !important;
  }
`;
